<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="customers"
        :table-select="false"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="客户编号">
              <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="经销商名称">
              <el-input v-model.trim="filter.dealName" placeholder="请输入经销商名称" clearable/>
            </el-form-item>
            <el-form-item label="客户分类">
              <el-select v-model="filter.classification" clearable placeholder="请选择标识">
                <el-option label="全部" value=""/>
                <el-option label="大客户(未税销售金额>1000万)" value="A"/>
                <el-option label="中等客户(未税销售金额>500万)" value="B"/>
                <el-option label="小客户(未税销售金额>100万)" value="C"/>
                <el-option label="小客户(未税销售金额<100万)" value="D"/>
                <el-option label="集团内部客户" value="E"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户属性">
              <el-select v-model="filter.attributes" clearable placeholder="请选择标识">
                <el-option label="全部" value="-1"/>
                <el-option label="成交客户" value="1"/>
                <el-option label="潜在客户" value="2"/>
                <el-option label="直销客户" value="3"/>
                <el-option label="经销客户" value="4"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <!--        <el-button v-if="limits.creditAuth" type="primary" @click="$refs.customerCredit.open(scope.row)">信贷</el-button>-->
      </template>
    </view-table>
    <customer-edit ref="customerEdit" :options="options" @save-success="loadData(1)"/>
    <customer-credit ref="customerCredit"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import CustomerEdit from "./CustomerEdit.vue";
  import CustomerCredit from "@/views/information/Customer/CustomerCredit";
  export default {
    name: "CustomerList",
    components: { ViewTable, CustomerEdit,CustomerCredit },

    data() {
      return {
        limits: {
          // addAuth: this.$auth(101),
          editAuth: this.$auth(102),
          // delAuth: this.$auth(103),
          creditAuth: this.$auth(234),
        },
        filter: {
          customerNo: "",
          customerName: "",
          classification: "",
          attributes: "",
          dealName:"",
        },
        columnsProperty: [
          {
            key: "outerNo",
            width: 90,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.customerEdit.open(params.row, false);
                    },
                  },
                },
                params.row.outerNo
              );
            },
          },
          {
            key: "customerName",
            minWidth: 260,
          },
          {
            key: "customerLevelName",
            width: 90,
            align: "center",
          },
          {
            key: "customerGroupName",
            width: 90,
            align: "center",
          },
          {
            key: "contact",
            width: 90,
            align: "center",
          },
          {
            key: "telephone",
            width: 120,
            align: "center",
          },
          {
            key: "address",
            minWidth: 260,
          },
          {
            key: "greenChannel",
            width: 90,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.greenChannel ? "是" : "否");
            },
          },
          {
            key: "creatorName",
            width: 90,
            align: "center",
          },
          {
            key: "createdTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
        options: [], // 所属区域
      };
    },

    created() {
      // this.getAreaOptions();
    },

    methods: {
      // 查询客户列表
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新建 编辑
      addEditHandle(row) {
        this.$refs.customerEdit.open(row,true);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "customers", row.customerID).then((resp) => {
          if (resp.success) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      // 查询所属区域(由于数据量较大 放在列表页查询后通过options传递)
      getAreaOptions() {
        this.$http.get("basic", "districts/selectAllDistrict").then((res) => {
          if (res.success) {
            this.options = res.data;
          }
        });
      },
    },
  };
</script>
